import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

// Map slug -> category name in Hindi (matches backend seeded names)
const SLUG_TO_NAME = {
  rajniti: "राजनीति", khel: "खेल", manoranjan: "मनोरंजन", vyapar: "व्यापार",
  rashtriya: "राष्ट्रीय", antarrashtriya: "अंतरराष्ट्रीय", sthaniya: "स्थानीय", takniki: "तकनीक",
};

export default function CategoryPage() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const catName = SLUG_TO_NAME[slug] || slug;

  useEffect(() => {
    // slug may be Hindi if coming from article page; try both
    const category = SLUG_TO_NAME[slug] || decodeURIComponent(slug);
    api.get("/news", { params: { category, limit: 60 } })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <>
      <PublicHeader />
      <main className="max-w-7xl mx-auto px-4 py-10" data-testid="category-page">
        <div className="mb-8">
          <div className="tag-cat mb-2">श्रेणी</div>
          <h1 className="font-devnagri-heading text-4xl font-black text-[#0F172A]">{catName}</h1>
        </div>
        {loading ? <div className="text-slate-500">लोड हो रहा है…</div> : (
          items.length === 0 ? <div className="text-slate-500">इस श्रेणी में कोई समाचार नहीं।</div> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((n) => (
              <Link key={n.id} to={`/article/${n.slug}`} className="group relative" data-testid={`cat-item-${n.id}`}>
                {n.is_editorial && (
                  <span className="absolute -top-1 -left-1 z-10 bg-gradient-to-r from-[#EA580C] to-[#DC2626] text-white text-[9px] uppercase tracking-widest font-bold px-2 py-1 rounded-tr rounded-bl">✦ संपादकीय</span>
                )}
                <div className="img-hover-zoom rounded-md aspect-video bg-slate-200 mb-3">
                  {n.image_url && <img src={n.image_url} alt={n.title} className="w-full h-full object-cover"/>}
                </div>
                <h3 className="font-devnagri-heading font-bold text-lg leading-snug news-title text-[#0F172A] line-clamp-3">{n.title}</h3>
                <p className="text-sm text-slate-600 mt-1 line-clamp-2">{n.excerpt}</p>
                <div className="text-xs text-slate-500 font-admin mt-2">— {n.author}</div>
              </Link>
            ))}
          </div>
          )
        )}
      </main>
      <PublicFooter />
    </>
  );
}
